import { useContext, useEffect, useMemo, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import { arrayMove } from "@dnd-kit/sortable";
import { useCommon } from "../Pocker/useCommon";


export const useConfigure = ({ filterValues, setFilterValues }) => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const { lockedLayoutFields } = useCommon();
    const [initialDisplayJson, setInitialDisplayJson] = useState({});
    const [loader, setLoader] = useState({ fields: false, area: false, saveBtn: false, copyBtn: false });
    const [hoverArea, setHoverArea] = useState(null);
    const [displayJson, setDisplayJson] = useState({ api: {}, current: {}, fixed: {} });
    const [dragPreview, setDragPreview] = useState(null);
    const [copy, setCopy] = useState({ visible: false, destination: [], opts: [] });
    const [collapsedId, setCollapsedId] = useState(null);
    const [activeField, setActiveField] = useState(null);
    const [fields, setFields] = useState({
        search: "", list: {},
        // "Date & Time": [
        //     { id: 1, name: "Issue Created", key: "created_datetime", type: "date" },
        //     { id: 2, name: "Due date", key: "due_date", type: "date" }
        // ],
        // "People": [
        //     { id: 3, name: "Assignee",key:"assignee_user_code", optionKey: "users", type: "select" },
        //     { id: 4, name: "Reporter", key: "reporter_user_code", optionKey: "users", type: "select" },
        //     { id: 5, name: "Code Reviewer", type: "select" },
        //     { id: 6, name: "TMS Assignee", type: "text" },
        //     { id: 7, name: "Work Loggers", type: "select" }
        // ],
        // "Number": [
        //     { id: 8, name: "TMS Id", type: "text" },
        //     { id: 9, name: "Original estimate", type: "text" },
        //     { id: 10, name: "Remaining Estimate", type: "text" }
        // ],
        // "Project/Sprint": [
        //     { id: 11, name: "Summary", type: "textarea", col: "12" },
        //     { id: 12, name: "Description", placeholder: "Add a description...", type: "textarea", col: "12" },
        //     { id: 13, name: "Status", type: "select" },
        //     { id: 14, name: "Priority", key: "priority_name", optionKey: "priority", type: "select" },
        //     { id: 15, name: "Sprint", type: "select" },
        //     { id: 16, name: "Sprint Tag", type: "select" },
        //     { id: 17, name: "Tms Sprint Name", type: "text" },
        //     { id: 18, name: "Sub-Project", type: "select" },
        //     { id: 19, name: "Project Module", type: "select" },
        //     { id: 20, name: "TMS Project Name", type: "text" }
        // ],
        // "Components & Versions": [
        //     { id: 24, name: "Components", type: "select" },
        //     { id: 25, name: "Fix versions", type: "text" }
        // ],
        // "Planning & Tracking": [
        //     { id: 26, name: "Acceptance Criteria", type: "textarea", col: "12" },
        //     { id: 27, name: "Ownership" },
        //     { id: 28, name: "Insight Buckets" }
        // ]
    });
    const dataTypeLabel = {
        datetime: "Date & Time",
        date: "Date & Time",
        number: "Number",
        user: "People & Groups",
        string: "Text",
        array: "Select",
        option: "Select",
        priority: "Select",
    };

    useEffect(() => {
        sessionStorage.removeItem("screen_schemes");
        callautopopulate("layout_types", "screen_schemes")?.then(res => {
            let layout = {};
            res?.layout_types?.forEach(item => {
                layout[item?.layout_name] = { ...item, fields: [], info: item?.layout_name === "Description Fields" ? "Add your most important fields here so that they appear in the main content area of an issue." : item?.layout_name === "Context Fields" ? 'Add fields here to set more context of the work. These fields will appear under "Details" in an issue.' : item?.layout_name === "Context Fields Optional" ? 'Add fields here to hide them when empty. These fields will appear under "More Fields" in an issue.' : "" }
            })
            setInitialDisplayJson(layout);
            setDisplayJson((prev) => ({ ...prev, api: layout, current: layout }));
            setCopy((prev) => ({ ...prev, opts: res?.screen_schemes?.filter(item => item?.screen_scheme_id !== filterValues?.layout?.screen_scheme_id).sort((a, b) => a?.screen_scheme_name?.localeCompare(b?.screen_scheme_name)) }))
        })
    }, [])

    useEffect(() => {
        if (filterValues?.apiCall && !_.isEmpty(initialDisplayJson)) {
            getFields();
            getLayout();
        }
    }, [filterValues?.apiCall, initialDisplayJson])

    const usedIds = useMemo(() => {
        return new Set(
            Object.values(displayJson?.current)?.flatMap((section) =>
                section?.fields?.map((f) => f?.custom_field_id)
            )?.concat(_.pluck(Object.values(displayJson?.fixed)?.flat(), "custom_field_id") || [])
        );
    }, [displayJson?.current, displayJson?.fixed]);

    const getFields = async () => {
        try {
            setLoader(prev => ({ ...prev, fields: true }));
            const payload = {
                screen_scheme_id: filterValues?.layout?.screen_scheme_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSCREENSCHEMEDETAILS"), payload);
            if (res?.body?.error_status === false) {
                const data = _.uniq(res?.body?.data?.scheme_screen_details, "custom_field_id");
                const formattedData = formatFields(data);
                setFields((prev) => ({ ...prev, list: formattedData }));

                // set fixed fields for the layout
                let locked = {};
                Object.entries(lockedLayoutFields)?.forEach(([key, value]) => {
                    locked[key] = [];
                    value?.forEach(fieldKey => {
                        const findData = _.findWhere(data, { custom_field_key: fieldKey });
                        if (findData) locked?.[key]?.push(findData);
                    })
                })
                setDisplayJson((prev) => ({ ...prev, fixed: locked }));
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader(prev => ({ ...prev, fields: false }));
            setFilterValues((prev) => ({ ...prev, apiCall: false }));
        }
    }

    const getLayout = async () => {
        try {
            setLoader(prev => ({ ...prev, area: true }));
            setDisplayJson((prev) => ({ ...prev, current: initialDisplayJson }));
            const payload = {
                screen_scheme_id: filterValues?.layout?.screen_scheme_id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSCREENSCHEMELAYOUT"), payload);
            if (res?.body?.error_status === false) {
                const data = res?.body?.data?.scheme_screen_layout_details;
                let json = { ...initialDisplayJson };
                const locked = Object.values(lockedLayoutFields)?.flat();
                Object.entries(_.groupBy(data, "layout_name"))?.forEach(([key, value]) => {
                    json = { ...json, [key]: { ...json?.[key], fields: _.sortBy(value, "order_number")?.filter(item => !locked?.includes(item?.custom_field_key)) } }
                })
                setDisplayJson(prev => ({ ...prev, api: json, current: json }));
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setFilterValues((prev) => ({ ...prev, apiCall: false }));
            setLoader(prev => ({ ...prev, area: false }));
        }
    }

    const saveLayout = async () => {
        try {
            if (_.isEqual(displayJson?.api, displayJson?.current)) {
                showInfo("Info", "No changes made!");
                return;
            }
            setLoader(prev => ({ ...prev, saveBtn: true }));
            let tvp = [];
            Object.entries(displayJson?.current)?.forEach(([key, value]) => {
                if (!_.isEmpty(value?.fields)) {
                    (displayJson?.fixed?.[key] ? displayJson?.fixed?.[key] : [])?.concat(value?.fields)?.forEach((field, index) => {
                        tvp.push({
                            scheme_layout_mapping_id: field?.scheme_layout_mapping_id || 0,
                            layout_id: value?.layout_id || 0,
                            custom_field_id: field?.custom_field_id || 0,
                            order_number: index + 1 || 0
                        })
                    })
                }
            })
            const payload = {
                screen_scheme_id: filterValues?.layout?.screen_scheme_id || 0,
                tvp_scheme_layout_mapping: tvp || []
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSCREENSCHEMELAYOUT"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                getLayout();
            } else {
                res?.body?.message && showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader(prev => ({ ...prev, saveBtn: false }));
        }
    }

    const copyLayout = async () => {
        try {
            if (_.isEmpty(copy?.destination)) {
                showInfo("Info", "No screen schemes selected");
                return;
            }
            setLoader(prev => ({ ...prev, copyBtn: true }));
            const payload = {
                source_screen_scheme_id: filterValues?.layout?.screen_scheme_id || 0,
                destination_screen_scheme_id: _.pluck(copy?.destination, "screen_scheme_id")?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSCREENSCHEMELAYOUTCOPY"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("Success", res?.body?.message);
                setCopy((prev) => ({ ...prev, visible: false, destination: [] }));
            } else {
                res?.body?.message && showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader(prev => ({ ...prev, copyBtn: false }));
        }
    }

    const formatFields = (data) => {
        const grouped = _.groupBy(data, "schema_type");
        let formattedData = {};
        Object.keys(grouped)?.map(key => { return { label: dataTypeLabel[key] ?? "Other", key } })?.sort((a, b) => a?.label?.localeCompare(b?.label))?.forEach(item => {
            formattedData[item?.label] = (formattedData[item?.label] ? [...formattedData[item?.label], ...grouped?.[item?.key]] : [...grouped?.[item?.key]])?.sort((a, b) => a?.custom_field_name?.localeCompare(b?.custom_field_name));
        })
        return formattedData
    }

    const getFieldById = (id) => {
        for (const group of Object.values(fields?.list)) {
            const found = group?.find((f) => f?.custom_field_id === id);
            if (found) return found;
        }
        return null;
    };

    const onDragStart = (e, field, sourceArea = null) => {
        e.dataTransfer.setData("fieldId", String(field?.custom_field_id));
        e.dataTransfer.setData("sourceArea", sourceArea || "");

        // image view for the element being dragged
        const img = new Image();
        img.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnLz4=";
        e.dataTransfer.setDragImage(img, 0, 0);
        setDragPreview({ x: e.clientX, y: e.clientY, field });

        // delay collapse slightly
        requestAnimationFrame(() => {
            setCollapsedId(field?.custom_field_id);
        });
    };

    const onDragOver = (e, area, index) => {
        e.preventDefault();
        setHoverArea(area);
    };

    const onDragEnd = () => {
        setDragPreview(null);
        setHoverArea(null);
        setCollapsedId(null);
    }

    const onDrop = (e, targetArea, targetIndex = null) => {
        e.preventDefault();
        onDragEnd();
        const id = Number(e.dataTransfer.getData("fieldId"));
        const sourceArea = e.dataTransfer.getData("sourceArea");
        const field = getFieldById(id);
        if (!field) return;


        setDisplayJson((prev) => {
            let newState = { ...prev?.current };
            if (!targetArea) {
                // to remove when dropped in right side area
                if (sourceArea) {
                    newState[sourceArea] = { ...prev?.current?.[sourceArea], fields: prev?.current?.[sourceArea]?.fields?.filter((f) => f?.custom_field_id !== id) };
                }
            } else {
                let updatedTargetFields = [...prev?.current?.[targetArea]?.fields];

                if (sourceArea === targetArea) {
                    updatedTargetFields = updatedTargetFields?.filter(f => f?.custom_field_id !== id);
                } else if (sourceArea) {
                    newState[sourceArea] = { ...prev?.current?.[sourceArea], fields: prev?.current?.[sourceArea]?.fields?.filter((f) => f?.custom_field_id !== id) };
                }
                const insertAt = targetIndex !== null ? targetIndex : updatedTargetFields?.length;
                updatedTargetFields?.splice(insertAt, 0, field);

                newState[targetArea] = { ...prev?.current?.[targetArea], fields: updatedTargetFields };
            }
            return { ...prev, current: newState };
        });
    };

    const onDrag = (e) => {
        if (e.clientX === 0 && e.clientY === 0) return;
        setDragPreview((prev) => prev ? { ...prev, x: e.clientX, y: e.clientY } : null);
    };

    const removeFromSection = (id, targetArea) => {
        setDisplayJson((prev) => {
            return { ...prev, current: { ...prev?.current, [targetArea]: { ...prev?.current?.[targetArea], fields: prev?.current?.[targetArea]?.fields?.filter((f) => f?.custom_field_id !== id) } } };
        });
    };

    const handleDndDragEnd = (event) => {
        setHoverArea(null);
        setActiveField(null);
        const { active, over } = event;

        if (!over) {
            setActiveField(null);
            return;
        }

        const activeId = active?.id;
        const overId = over?.id;

        const sourceArea = active?.data?.current?.area;

        let destinationArea = null;

        // Find destination section
        Object.keys(displayJson?.current || {})?.forEach((area) => {
            const exists = displayJson?.current?.[area]?.fields?.some((f) => f.custom_field_id === overId);
            if (exists) {
                destinationArea = area;
            }
        });

        // dropped on empty area
        if (!destinationArea && displayJson?.current?.[overId]) {
            destinationArea = overId;
        }

        if (!sourceArea || !destinationArea) return;

        const sourceFields = [...displayJson?.current?.[sourceArea]?.fields];

        const destinationFields = sourceArea === destinationArea ? sourceFields : [...displayJson?.current?.[destinationArea]?.fields];

        const activeIndex = sourceFields?.findIndex((f) => f?.custom_field_id === activeId);

        const overIndex = destinationFields?.findIndex((f) => f?.custom_field_id === overId);

        // SAME CONTAINER SORTING
        if (sourceArea === destinationArea) {
            const reordered = arrayMove(sourceFields, activeIndex, overIndex);
            setDisplayJson((prev) => ({ ...prev, current: { ...prev.current, [sourceArea]: { ...prev.current[sourceArea], fields: reordered } } }));
            return;
        }

        // MOVE BETWEEN SECTIONS
        const movedItem = sourceFields[activeIndex];

        sourceFields.splice(activeIndex, 1);

        if (overIndex >= 0) {
            destinationFields.splice(overIndex, 0, movedItem);
        } else {
            destinationFields.push(movedItem);
        }

        setDisplayJson((prev) => ({ ...prev, current: { ...prev.current, [sourceArea]: { ...prev.current[sourceArea], fields: sourceFields }, [destinationArea]: { ...prev.current[destinationArea], fields: destinationFields } } }));
    };

    const handleDndDragOver = (event) => {
        const { over } = event;

        if (!over) {
            setHoverArea(null);
            return;
        }

        const overId = over.id;

        // hovering directly over section
        if (displayJson?.current?.[overId]) {
            setHoverArea(overId);
            return;
        }

        // hovering over item inside section
        Object.keys(displayJson?.current || {}).forEach((area) => {
            const exists = displayJson?.current?.[area]?.fields?.some((f) => f.custom_field_id === overId);
            if (exists) {
                setHoverArea(area);
            }
        });
    }

    const filteredFields = useMemo(() => {
        if (!fields?.search?.trim()) return fields;
        const data = Object?.values(fields?.list)?.flat()?.filter((item) => item?.custom_field_name?.toLowerCase()?.includes(fields?.search.toLowerCase()));
        const formattedFields = formatFields(data)
        return { ...fields, list: formattedFields };
    }, [fields]);

    return { onDragStart, onDragOver, onDrop, usedIds, hoverArea, setHoverArea, displayJson, setDisplayJson, fields: filteredFields, setFields, removeFromSection, onDrag, dragPreview, loader, onDragEnd, saveLayout, copy, setCopy, copyLayout, collapsedId, activeField, setActiveField, handleDndDragEnd, handleDndDragOver };
};